import flags from "../../utils/flags";

const reducer = async (action, data, state) => {
  const primaryField = state.primaryField;

  switch (action) {
    case "CHANGE":
      const akc = {
        akc: [],
        disabled: data.obj.ref.current.getDisabled(),
        hidden: data.obj.ref.current.getHidden()
      }
      state.akc = akc

      if (state[primaryField]?.detailData?.DefOb?.LUz === false) {
        state.akc.disabled = state.akc.disabled | flags.SAVE
      }
      else {
        state.akc.disabled &= ~flags.SAVE
      }
      return state;
    default:
      return state;
  }
}

export default reducer;